//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext } from '../../../Context/ExpressionContext';

// === API ===

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function DataTypeSelect( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const _datatype_items = [
    { label: 'Amount'   , value: 'amount'    },
    { label: 'Date'     , value: 'date'      },
    { label: 'String'   , value: 'string'    },
  ]

  const { updateExpression } = useContext( ExpressionContext );

  const [ type_value, setTypeValue ] = useState( props.type || 'string' );
  const [ type_label, setTypeLabel ] = useState( props.type || 'String' );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_datatype: {
      width: '9rem',
    },
  }

  const SELECT_DATATYPE = {
    sx       : _styles.select_datatype,
    labelId  : 'datatype-label',
    id       : 'datatype-select',
    options  : _datatype_items,
    value    : type_value,
    size     : 'small',
    onChange : onChange_Type,
    children : _datatype_items.map( item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)
  };
    
  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange_Type( event ) {
    //-----------------------------------------------------------------
    setTypeValue( event.target.value );
    updateExpression( props.id , { type: event.target.value } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <FormControl>
        <InputLabel id="datatype-label">Type</InputLabel>
        <Select   { ...SELECT_DATATYPE } />
      </FormControl>
    );
  }

  //#endregion

  return display();
}
